"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_4g__plus__plus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4GG",
    "data-name": "4GG",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 191.5",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.25a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.25Z",
    transform: "translate(0 -0.25)",
    style: {
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,69H53.06L30,103.26V111H51v10H61V111h5v-9H61ZM51,102H40L51,85.34Z",
    transform: "translate(0 -0.25)",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,102h8v9.34a12.61,12.61,0,0,1-2.14.51,27.11,27.11,0,0,1-4.83.35,13.4,13.4,0,0,1-5.85-1.44c-2-1-3.68-2.91-5-5.84a24.44,24.44,0,0,1-2-10.31,31.93,31.93,0,0,1,1.2-8.84,13.76,13.76,0,0,1,4-6.73,9.08,9.08,0,0,1,6.23-2.49,11.68,11.68,0,0,1,4.2.81,10.88,10.88,0,0,1,3.52,2.18,12.74,12.74,0,0,1,2.4,3.16l6.6-6.31a16.83,16.83,0,0,0-6.22-6.5A22,22,0,0,0,85.46,69a18.54,18.54,0,0,0-6.71,5A25,25,0,0,0,74.1,82.5a37.9,37.9,0,0,0-1.72,12.11A36.71,36.71,0,0,0,74,106a24.68,24.68,0,0,0,4.54,8.45,19,19,0,0,0,7,5.25,22.13,22.13,0,0,0,9,1.79,42.28,42.28,0,0,0,10.35-1.09A21.36,21.36,0,0,0,111,118V93H94Z",
    transform: "translate(0 -0.25)",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 92.75,
    width: 24,
    height: 6,
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 93,
    width: 24,
    height: 6,
    transform: "translate(224 -32.25) rotate(90)",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 92.75,
    width: 24,
    height: 6,
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 93,
    width: 24,
    height: 6,
    transform: "translate(252 -60.25) rotate(90)",
    style: {
      fill: "#e60000"
    }
  }));
}

var _default = ic_4g__plus__plus;
exports.default = _default;